import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoDeclaracionSituacionActividad = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoDeclaracionSituacionActividad = () => {
  const [loadingGetInfoDeclaracionSituacionActividad, setLoadingGetInfoDeclaracionSituacionActividad] = useState(false);
  const [successGetInfoDeclaracionSituacionActividad, setSuccessGetInfoDeclaracionSituacionActividad] = useState(false);
  const [errorGetInfoDeclaracionSituacionActividad, setErrorGetInfoDeclaracionSituacionActividad] = useState<any>(null);
  const [dataGetInfoDeclaracionSituacionActividad, setDataGetInfoDeclaracionSituacionActividad] = useState<any>(null);

  const [statusGetInfoDeclaracionSituacionActividad, setStatusGetInfoDeclaracionSituacionActividad] =
    useState<StatusGetInfoDeclaracionSituacionActividad>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoDeclaracionSituacionActividad = async (
    
    userId: any,
    expedienteId: string,
    
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoDeclaracionSituacionActividad(true);
    setSuccessGetInfoDeclaracionSituacionActividad(false);
    setErrorGetInfoDeclaracionSituacionActividad(null);

    try {
      const res = await apiRecord.getInfoDeclaracionSituacionActividadIt(userId, expedienteId);

      setStatusGetInfoDeclaracionSituacionActividad({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetInfoDeclaracionSituacionActividad(true);
      setDataGetInfoDeclaracionSituacionActividad(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;
    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetInfoDeclaracionSituacionActividad({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetInfoDeclaracionSituacionActividad(err);
      console.error("Error en getInfoDeclaracionSituacionActividad:", err);

      throw err;

    } finally {
      setLoadingGetInfoDeclaracionSituacionActividad(false);
    }
  };

  return {
    getInfoDeclaracionSituacionActividad,
    loadingGetInfoDeclaracionSituacionActividad,
    successGetInfoDeclaracionSituacionActividad,
    errorGetInfoDeclaracionSituacionActividad,
    dataGetInfoDeclaracionSituacionActividad,
    statusGetInfoDeclaracionSituacionActividad
  };
};

export default useGetInfoDeclaracionSituacionActividad;
